export const toKebab = (str) => {
	return String(str)
		.replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
		.replace(/([a-z])([A-Z])/g, (m, a, b) => `${a}_${b.toLowerCase()}`)
		.replace(/[^A-Za-z0-9]+|_+/g, '-')
		.toLowerCase();
}

export const toCamel = (str) => {
	return String(str)
		.replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
		.replace(/[^A-Za-z0-9]+/g, '$')
		.replace(/([a-z])([A-Z])/g, (m, a, b) => `${a}$${b}`)
		.toLowerCase()
		.replace(/(\$)(\w)/g, (m, a, b) => b.toUpperCase());
}